import React, { useState, useEffect } from 'react';
import './TechCarousel.css';

const TechCarousel = () => {
  const technologies = [
    { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
    { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
    { name: 'Vite', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vitejs/vitejs-original.svg' },
    { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
    { name: 'HTML', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
    { name: 'CSS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
    { name: 'Tailwind CSS', icon: 'https://www.svgrepo.com/show/374118/tailwind.svg' },
    { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
    { name: 'MySQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
    { name: 'PostgreSQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
    { name: 'Next.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg' },
    { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg' },
    { name: 'Git', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg' },
    { name: 'GitHub', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg' },
    { name: 'Figma', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg' },
    { name: 'OpenAI', icon: 'https://cdn.brandfetch.io/idR3duQxYl/theme/light/symbol.svg?c=1bxid64Mup7aczewSAYMX&t=1749527480180' },
  ];

  const [visibleStart, setVisibleStart] = useState(0);
  const visibleCount = 7; // Número de logos visibles a la vez
  
  // Configuración para la rotación automática
  const autoRotationSpeed = 2000; // milisegundos entre cambios (2 segundos)

  useEffect(() => {
    // Crear un intervalo para la rotación automática
    const interval = setInterval(() => {
      setVisibleStart((current) => (current + 1) % technologies.length);
    }, autoRotationSpeed);

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(interval);
  }, [technologies.length, autoRotationSpeed]);

  const getVisibleTechnologies = () => {
    const result = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (visibleStart + i) % technologies.length;
      result.push(technologies[index]);
    }
    return result;
  };

  return (
    <div className="tech-carousel-container">
      <div className="tech-carousel">
        <div className="tech-slider">
          {getVisibleTechnologies().map((tech, index) => (
            <div key={index} className="tech-item">
              <img
                src={tech.icon}
                alt={tech.name}
                title={tech.name}
                className="tech-icon"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechCarousel;